import { type ISubscription } from "src/pages/Management/Subscriptions/Subscriptions.types";
import { StyledTd } from "src/styled";

import SubsRow from "./SubsRow";
interface Props {
  row: ISubscription;
}
const SubsRowWithClient = ({ row }: Props) => {
  return (
    <SubsRow row={row}>
      <StyledTd>{row.clientname}</StyledTd>
      <StyledTd center>{row.yachtname}</StyledTd>
    </SubsRow>
  );
};
export default SubsRowWithClient;
